import jQuery from "jquery";

/**
 * Helper code for modal windows.
 *
 * The following concepts are relevant here:
 *
 * - trigger : an element with a click listener, that acts as a toggle for the visibility of the modal
 * - target : the element that will be displayed (ie, the "modal")
 */
export default function init() {

    jQuery(document).on("keyup", function(event) {
        if (event.key === "Escape") {
            jQuery(".js-modal").removeClass("active");
        }
    });

    jQuery(document).on("click", ".js-modal-trigger",function(event: JQueryEventObject) {

        const trigger = jQuery(this);
        const origin = event.target;
        const sel = trigger.data("target");
        const modal = sel ? jQuery(sel) : trigger.closest(".js-modal");

        if (modal.length) {

            // If event came from within the modal itself,
            // and the trigger is outside the modal, ignore.
            // This could happen eg if the modal is located as a descendant of the trigger.

            const eventFromInside = jQuery.contains(modal[0], origin);
            const triggerOutside = ! jQuery.contains(modal[0], trigger[0]);
            if (eventFromInside && triggerOutside) {
                return;
            }

            event.stopPropagation();
            event.preventDefault();
        }

        modal.toggleClass("active");

        // --------------------------------

    });

    jQuery(document).on("click", ".js-modal",function(event: JQueryEventObject) {

        const trigger = jQuery(event.target);
        if (trigger.hasClass("js-modal")) {
            // It's the background
            event.stopPropagation();
            event.preventDefault();
            trigger.toggleClass("active");
        }
    });

}

export function dismissModal(elt: JQuery<HTMLElement>) {
    elt.removeClass("active");
}

